import React, { useRef, useEffect } from 'react';
import '../App.css';
import { Button } from './Button';
import { useHistory } from 'react-router-dom';
import './HeroSection.css';

function HeroSection() {
  const history = useHistory();
  const videoRef = useRef(null);
  const idleTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    };
  }, []);

  const handleVideoEnded = () => {
    idleTimerRef.current = setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        videoRef.current.play().catch(() => {});
      }
    }, 10000);
  };

  return (
    <div className='hero-container'>
      <video
        ref={videoRef}
        className="hero-video"
        src='/videos/coretezvideo1.mp4'
        autoPlay
        muted
        onEnded={handleVideoEnded}
      />
      <h1>Coretez</h1>
      <p>Blog, News, Tools</p>
      <div className='hero-btns'>
        <div className='hero-btns-row'>
          <Button
            className='btns'
            buttonStyle='btn--outline'
            buttonSize='btn--large'
            onClick={() => history.push('/content')}
          >
            Blog Content
          </Button>
          <Button
            className='btns'
            buttonStyle='btn--outline'
            buttonSize='btn--large'
            onClick={() => history.push('/tools')}
          >
            Useful Tools
          </Button>
        </div>
        <div className='hero-btns-row hero-btns-row--center'>
          <Button
            className='btns'
            buttonStyle='btn--outline'
            buttonSize='btn--large'
            onClick={() => history.push('/about/coming-soon')}
          >
            Coming Soon
          </Button>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
